/**
 * 电子地图配置（localStorage 持久化）
 * 小车轨迹相关配置均在此，含边界校验与异常处理
 */
const STORAGE_KEY = 'electronicMapSettings';

const DEFAULTS = {
  // 背景路线
  routeColor: 'rgba(255, 69, 0, 0.68)',
  routeWidth: 6,
  routeBaseAlpha: 0.24,
  // 小车轨迹 - 线条
  passedRouteColor: '#0000ff',
  notPassedRouteColor: '#ff0000',
  trajectoryLineWeight: 6,
  trajectoryLineOpacity: 0.9,
  // 小车轨迹 - 动画
  carSpeed: 500,
  interval: 25,
  showHistoryTrack: '1',
  loopPlay: true,
  // 小车轨迹 - 图标
  carIconSize: 28,
  carEmoji: '🚗',
  // 小车轨迹 - 提示
  showTooltip: true,
  // 其他（箭头等，暂未接入轨迹）
  showArrow: true,
  offset: 30,
  repeat: 60,
  pixelSize: 5,
  headAngle: 75,
  arrowColor: '#ffffff',
  weight: 3
};

function clamp(num, min, max, def) {
  const n = Number(num);
  if (Number.isNaN(n)) return def;
  return Math.max(min, Math.min(max, n));
}

function parseAlpha(val, def) {
  const n = Number(val);
  if (Number.isNaN(n)) return def;
  return Math.max(0, Math.min(1, n));
}

function parseColor(val, def) {
  if (typeof val !== 'string' || !val.trim()) return def;
  return String(val).trim();
}

export function getElectronicMapSettings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return {
      routeColor: parseColor(parsed.routeColor, DEFAULTS.routeColor),
      routeWidth: clamp(parsed.routeWidth, 1, 20, DEFAULTS.routeWidth),
      routeBaseAlpha: parseAlpha(parsed.routeBaseAlpha, DEFAULTS.routeBaseAlpha),
      passedRouteColor: parseColor(parsed.passedRouteColor, DEFAULTS.passedRouteColor),
      notPassedRouteColor: parseColor(parsed.notPassedRouteColor, DEFAULTS.notPassedRouteColor),
      trajectoryLineWeight: clamp(parsed.trajectoryLineWeight, 1, 20, DEFAULTS.trajectoryLineWeight),
      trajectoryLineOpacity: parseAlpha(parsed.trajectoryLineOpacity, DEFAULTS.trajectoryLineOpacity),
      carSpeed: clamp(parsed.carSpeed, 0, 9999, DEFAULTS.carSpeed),
      interval: clamp(parsed.interval, 10, 500, DEFAULTS.interval),
      showHistoryTrack: parsed.showHistoryTrack === '0' ? '0' : '1',
      loopPlay: parsed.loopPlay === false ? false : true,
      carIconSize: clamp(parsed.carIconSize, 16, 64, DEFAULTS.carIconSize),
      carEmoji: typeof parsed.carEmoji === 'string' ? (parsed.carEmoji || DEFAULTS.carEmoji) : DEFAULTS.carEmoji,
      showTooltip: parsed.showTooltip === false ? false : true,
      showArrow: parsed.showArrow === false ? false : true,
      offset: clamp(parsed.offset, 0, 100, DEFAULTS.offset),
      repeat: clamp(parsed.repeat, 0, 100, DEFAULTS.repeat),
      pixelSize: clamp(parsed.pixelSize, 0, 10, DEFAULTS.pixelSize),
      headAngle: clamp(parsed.headAngle, 0, 100, DEFAULTS.headAngle),
      arrowColor: parseColor(parsed.arrowColor, DEFAULTS.arrowColor),
      weight: clamp(parsed.weight, 0, 10, DEFAULTS.weight)
    };
  } catch (e) {
    return { ...DEFAULTS };
  }
}

export function saveElectronicMapSettings(settings) {
  try {
    const merged = { ...DEFAULTS, ...settings };
    const toSave = {
      routeColor: parseColor(merged.routeColor, DEFAULTS.routeColor),
      routeWidth: clamp(merged.routeWidth, 1, 20, DEFAULTS.routeWidth),
      routeBaseAlpha: parseAlpha(merged.routeBaseAlpha, DEFAULTS.routeBaseAlpha),
      passedRouteColor: parseColor(merged.passedRouteColor, DEFAULTS.passedRouteColor),
      notPassedRouteColor: parseColor(merged.notPassedRouteColor, DEFAULTS.notPassedRouteColor),
      trajectoryLineWeight: clamp(merged.trajectoryLineWeight, 1, 20, DEFAULTS.trajectoryLineWeight),
      trajectoryLineOpacity: parseAlpha(merged.trajectoryLineOpacity, DEFAULTS.trajectoryLineOpacity),
      carSpeed: clamp(merged.carSpeed, 0, 9999, DEFAULTS.carSpeed),
      interval: clamp(merged.interval, 10, 500, DEFAULTS.interval),
      showHistoryTrack: merged.showHistoryTrack === '0' ? '0' : '1',
      loopPlay: merged.loopPlay === false ? false : true,
      carIconSize: clamp(merged.carIconSize, 16, 64, DEFAULTS.carIconSize),
      carEmoji: typeof merged.carEmoji === 'string' ? (merged.carEmoji || DEFAULTS.carEmoji) : DEFAULTS.carEmoji,
      showTooltip: merged.showTooltip === false ? false : true,
      showArrow: merged.showArrow === false ? false : true,
      offset: clamp(merged.offset, 0, 100, DEFAULTS.offset),
      repeat: clamp(merged.repeat, 0, 100, DEFAULTS.repeat),
      pixelSize: clamp(merged.pixelSize, 0, 10, DEFAULTS.pixelSize),
      headAngle: clamp(merged.headAngle, 0, 100, DEFAULTS.headAngle),
      arrowColor: parseColor(merged.arrowColor, DEFAULTS.arrowColor),
      weight: clamp(merged.weight, 0, 10, DEFAULTS.weight)
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
    return toSave;
  } catch (e) {
    return getElectronicMapSettings();
  }
}

export { DEFAULTS };
